import "./ImagesList.css";
import ScrollAnimation from "../ScrollAnimation/ScrollAnimation";

const ImagesList = ({ data }) => {
    return (
        <div className="images-list">
            {data.map((item, index) => (
                <ScrollAnimation
                    type="revealUp"
                    delay={index * 100}
                    className="image-list-item"
                    key={index}
                >
                    <div className="image-list-heading">{item.title}</div>

                    <img src={item.image} alt={item.title} className="image-list-image" />

                    <div className="image-list-content">{item.content}</div>
                </ScrollAnimation>
            ))}
        </div>
    );
};

export default ImagesList;
